// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    UpdatePrice,
} from "@insite/client-framework/Store/Pages/RfqQuoteDetails/Handlers/ApplyPriceBreakDiscount";
import updatePriceBreakPrice from "@insite/client-framework/Store/Pages/RfqQuoteDetails/Handlers/UpdatePriceBreakPrice";

export const XngUpdatePrice: any = (props: any) => {
    const {
        dispatch,
        getState,
        parameter: { index },
        result: { priceWithDiscount },
    } = props;
    const { isFixedQty, minQty } = props.parameter;
    updatePriceBreakPrice({ index, price: priceWithDiscount, isFixedQty, minQty } as any)(dispatch, getState);
};

replaceInChain(chain, UpdatePrice, XngUpdatePrice);
